var map = {
	"./Association/bg@2x.png": "6c87",
	"./Association/业务领域/体育公益_1@2x.png": "137d",
	"./Association/业务领域/体育公益_2@2x.png": "722a",
	"./Association/业务领域/体育公益_3@2x.png": "a18c",
	"./Association/业务领域/体育培训_1@2x.png": "f97c",
	"./Association/业务领域/体育培训_2@2x.png": "0fbf",
	"./Association/业务领域/健康管理@2x.png": "9c81",
	"./Association/业务领域/品牌赛事_1@2x.png": "248e",
	"./Association/业务领域/品牌赛事_2@2x.png": "55e8",
	"./Association/业务领域/品牌赛事_3@2x.png": "7a24",
	"./Association/业务领域/品牌赛事_4@2x.png": "3177",
	"./Association/业务领域/品牌赛事_5@2x.png": "485b",
	"./Association/业务领域/整合营销_1@2x.png": "fe6d",
	"./Association/业务领域/整合营销_2@2x.png": "49a1",
	"./Association/业务领域/整合营销_3@2x.png": "997a",
	"./Association/业务领域/赛事系统@2x.png": "f94a",
	"./Association/业务领域/运动康养_1@2x.png": "cb7a",
	"./Association/业务领域/运动康养_2@2x.png": "7e19",
	"./Association/会刊/会刊框@2x.png": "7969",
	"./Association/会员/10@2x.png": "2167",
	"./Association/会员/11@2x.png": "fd59",
	"./Association/会员/12@2x.png": "0b91",
	"./Association/会员/13@2x.png": "5467",
	"./Association/会员/14@2x.png": "e4b8",
	"./Association/会员/15@2x.png": "6b4f",
	"./Association/会员/16@2x.png": "12bc",
	"./Association/会员/17@2x.png": "d6f2",
	"./Association/会员/18@2x.png": "eaa1",
	"./Association/会员/19@2x.png": "b920",
	"./Association/会员/1@2x.png": "eece",
	"./Association/会员/20@2x.png": "234a",
	"./Association/会员/21@2x.png": "420e",
	"./Association/会员/2@2x.png": "dd5e",
	"./Association/会员/3@2x.png": "313b",
	"./Association/会员/4@2x.png": "4e3c",
	"./Association/会员/5@2x.png": "858a",
	"./Association/会员/6@2x.png": "953d",
	"./Association/会员/7@2x.png": "c095",
	"./Association/会员/8@2x.png": "5854",
	"./Association/会员/9@2x.png": "2f04",
	"./Association/协会官媒@2x.png": "2903",
	"./Association/合作资源/上汽通用五菱@2x.png": "7763",
	"./Association/合作资源/世界企业体育协会@2x.png": "6c41",
	"./Association/合作资源/东风汽车@2x.png": "2060",
	"./Association/合作资源/中华儿慈会@2x.png": "c372",
	"./Association/合作资源/中国乒乓球协会@2x.png": "874e",
	"./Association/合作资源/中国企业联合会@2x.png": "3422",
	"./Association/合作资源/中国体育场馆协会@2x.png": "f8b3",
	"./Association/合作资源/中国健康管理协会@2x.png": "e1ba",
	"./Association/合作资源/中国卫星导航定位协会@2x.png": "7419",
	"./Association/合作资源/中国排球协会@2x.png": "0fad",
	"./Association/合作资源/中国桥牌协会@2x.png": "0ac8",
	"./Association/合作资源/中国网球协会@2x.png": "ff42",
	"./Association/合作资源/中国羽毛球协会@2x.png": "21fb",
	"./Association/合作资源/中国职工文化体育协会@2x.png": "590e",
	"./Association/合作资源/中国足协@2x.png": "9c7e",
	"./Association/合作资源/中国足球发展基金会@2x.png": "a4b6",
	"./Association/合作资源/中国钓鱼协会@2x.png": "85ed",
	"./Association/合作资源/中汽联@2x.png": "e808",
	"./Association/合作资源/亚奥理事会@2x.png": "7a45",
	"./Association/合作资源/北京体育大学@2x.png": "2c7a",
	"./Association/合作资源/国家体育总局@2x.png": "e3fe",
	"./Association/合作资源/国际电竞联合会@2x.png": "d5f2",
	"./Association/合作资源/安徽排球学院@2x.png": "c12e",
	"./Association/合作资源/巢湖学院@2x.png": "24f4",
	"./Association/合作资源/惠动乐@2x.png": "a44c",
	"./Association/合作资源/新浪体育@2x.png": "23f4",
	"./Association/合作资源/横店体育@2x.png": "4649",
	"./Association/合作资源/腾讯公益@2x.png": "6876",
	"./Association/合作资源/腾讯电竞@2x.png": "bb34",
	"./Association/合作资源/西甲联盟@2x.png": "6549",
	"./Association/合作资源/鞍山钢铁集团@2x.png": "9bc5",
	"./Association/投影@2x.png": "a001",
	"./Association/核心团队/冀运希@2x.png": "2731",
	"./Association/核心团队/刘凤岩@2x.png": "cc70",
	"./Association/核心团队/孙康林@2x.png": "6fb9",
	"./Association/核心团队/宋鲁增@2x.png": "6288",
	"./Association/核心团队/容志行@2x.png": "68ad",
	"./Association/核心团队/张世平@2x.png": "4021",
	"./Association/核心团队/张家顺@2x.png": "27a6",
	"./Association/核心团队/张长河@2x.png": "31ad",
	"./Association/核心团队/徐寅生@2x.png": "6240",
	"./Association/核心团队/惠若琪@2x.png": "0373",
	"./Association/核心团队/戚务生@2x.png": "bbc1",
	"./Association/核心团队/戴璐强@2x.png": "f66d",
	"./Association/核心团队/李富荣@2x.png": "8411",
	"./Association/核心团队/李忠@2x.png": "359b",
	"./Association/核心团队/段世杰@2x.png": "30ef",
	"./Association/核心团队/沈祥福@2x.png": "45e7",
	"./Association/核心团队/王小宁@2x.png": "e37b",
	"./Association/核心团队/陆元盛@2x.png": "56bd",
	"./Association/核心团队/雷平@2x.png": "473a",
	"./Association/核心团队/马元安@2x.png": "0802",
	"./Association/核心团队/高抒霞@2x.png": "fc20",
	"./athlete_certificate/list/奖章1级@2x.png": "9a86",
	"./athlete_certificate/list/奖章2级@2x.png": "903d",
	"./athlete_certificate/list/奖章3级@2x.png": "e160",
	"./athlete_certificate/list/奖章4级@2x.png": "5780",
	"./athlete_certificate/list/奖章5级@2x.png": "4e6e",
	"./athlete_certificate/奖章1级@2x.png": "b37e",
	"./athlete_certificate/奖章2级@2x.png": "58c5",
	"./athlete_certificate/奖章3级@2x.png": "b9ad",
	"./athlete_certificate/奖章4级@2x.png": "960f",
	"./athlete_certificate/奖章5级@2x.png": "a07a",
	"./athlete_certificate/模版@2x.png": "9a5d",
	"./athlete_certificate/盖章@2x.png": "5e8e",
	"./athlete_certificate/职工1级@2x.png": "8bd5",
	"./athlete_certificate/职工1级_2@2x.png": "02ab",
	"./athlete_certificate/职工2级@2x.png": "24b7",
	"./athlete_certificate/职工2级_2@2x.png": "c8df",
	"./athlete_certificate/职工3级@2x.png": "44ed",
	"./athlete_certificate/职工3级_2@2x.png": "8755",
	"./athlete_certificate/职工4级@2x.png": "0daa",
	"./athlete_certificate/职工4级_2@2x.png": "5a8e",
	"./athlete_certificate/职工5级@2x.png": "1637",
	"./athlete_certificate/职工5级_2@2x.png": "e130",
	"./btn_上传@2x.png": "f4e7",
	"./btn_上传_绿色@2x.png": "0875",
	"./certificate/icon_证书_A级赛事@2x.png": "3f8ce",
	"./certificate/icon_证书_B级赛事@2x.png": "2e0a",
	"./certificate/icon_证书_C级赛事@2x.png": "3b8b",
	"./certificate/icon_证书_D级赛事@2x.png": "60ae",
	"./certificate/icon_证书_E级赛事@2x.png": "ff63",
	"./certificate/文字_A级赛事@2x.png": "0118",
	"./certificate/文字_B级赛事@2x.png": "0942",
	"./certificate/文字_C级赛事@2x.png": "02abc",
	"./certificate/文字_D级赛事@2x.png": "556f",
	"./certificate/文字_E级赛事@2x.png": "42e1",
	"./certificate/盖章@2x.png": "9071",
	"./certificate/证书@2x.png": "e217",
	"./enroll/bubble_audit@2x.png": "0395",
	"./enroll/弹窗_bg@2x.png": "5cec",
	"./enroll/组合_hint@2x.png": "bb5a",
	"./enter/bubble_enroll_bg@2x.png": "567b",
	"./enter/报名提示_背板@2x.png": "8b6f",
	"./icon/add_deputation@2x.png": "cd62",
	"./icon/apply_league@2x.png": "dbe3",
	"./icon/card_arrow_down_4@2x.png": "beb2",
	"./icon/card_delete@2x.png": "bb9e",
	"./icon/card_delete_灰色@2x.png": "70f4",
	"./icon/checkbox_select@2x.png": "a5c3",
	"./icon/checkbox_select_orange@2x.png": "2f15",
	"./icon/checkbox_组合_未选中@2x.png": "a7f3",
	"./icon/checkbox_组合_选中_1@2x.png": "9e7b",
	"./icon/checkbox_组合_选中_2@2x.png": "a2c8",
	"./icon/checkbox_组合_选中_3@2x.png": "2ffb",
	"./icon/checkbox_组合_选中_4@2x.png": "5e72",
	"./icon/checkbox_组合_选中_5@2x.png": "b802",
	"./icon/checkbox_组合_选中_6@2x.png": "0b5f",
	"./icon/checkbox_组合_选中_7@2x.png": "803b",
	"./icon/delete_value@2x.png": "e32b",
	"./icon/down_hint@2x.png": "4c45",
	"./icon/edit_deputation@2x.png": "6b45",
	"./icon/file_excel@2x.png": "d5a6",
	"./icon/file_pdf@2x.png": "324f",
	"./icon/file_ppt@2x.png": "4a20",
	"./icon/file_word@2x.png": "21ff",
	"./icon/icon_WeChatPay@2x.png": "57f9",
	"./icon/icon_arrow_1@2x.png": "a4a6",
	"./icon/icon_arrow_down@2x.png": "8152",
	"./icon/icon_btn_arrow@2x.png": "2991",
	"./icon/icon_card_arrow@2x.png": "0c7e",
	"./icon/icon_card_arrow_2@2x.png": "795f",
	"./icon/icon_card_arrow_3@2x.png": "4cec",
	"./icon/icon_card_down@2x.png": "a87d",
	"./icon/icon_card_up@2x.png": "1f95",
	"./icon/icon_card_入口_black@2x.png": "a1bf",
	"./icon/icon_card_加@2x.png": "f536",
	"./icon/icon_card_向上@2x.png": "b470",
	"./icon/icon_card_向右@2x.png": "9a7a",
	"./icon/icon_card_未完成必填项提示_星号@2x.png": "851d",
	"./icon/icon_card_箭头_灰色_向上@2x.png": "a957",
	"./icon/icon_card_箭头_灰色_向下@2x.png": "148e",
	"./icon/icon_card_箭头_绿色_向上@2x.png": "c564",
	"./icon/icon_card_箭头_绿色_向下@2x.png": "4e05",
	"./icon/icon_check_selected@2x.png": "bb7a",
	"./icon/icon_check_unselected@2x.png": "0535",
	"./icon/icon_close@2x.png": "5bd6",
	"./icon/icon_dialog_close@2x.png": "e8f0",
	"./icon/icon_fileDownload@2x.png": "fc84",
	"./icon/icon_folding_down_1@2x.png": "574d",
	"./icon/icon_folding_up_1@2x.png": "b197",
	"./icon/icon_group@2x.png": "5b95",
	"./icon/icon_helpCenter_catalogue@2x.png": "802b",
	"./icon/icon_man@2x.png": "3d10",
	"./icon/icon_nav_back@2x.png": "9456",
	"./icon/icon_nav_back_white@2x.png": "ea08",
	"./icon/icon_nav_分享@2x.png": "a613",
	"./icon/icon_nav_分享_白色@2x.png": "22e4",
	"./icon/icon_pattern_left@2x.png": "e183",
	"./icon/icon_pattern_right@2x.png": "7a6e",
	"./icon/icon_plus@2x.png": "672d",
	"./icon/icon_publicTransfer@2x.png": "f67e",
	"./icon/icon_search@2x.png": "6fdc",
	"./icon/icon_search_black@2x.png": "525c",
	"./icon/icon_table_cell_arrow@2x.png": "01bb",
	"./icon/icon_toast_check@2x.png": "c13b",
	"./icon/icon_toast_error@2x.png": "8bcb",
	"./icon/icon_toast_loading@2x.png": "91ff",
	"./icon/icon_toast_warning@2x.png": "5522",
	"./icon/icon_update@2x.png": "7862",
	"./icon/icon_video_play@2x.png": "eace",
	"./icon/icon_woman@2x.png": "e0da",
	"./icon/icon_三角@2x.png": "4e88",
	"./icon/icon_下拉@2x.png": "19da",
	"./icon/icon_下拉箭头_灰色_向上@2x.png": "18bd",
	"./icon/icon_下拉箭头_灰色_向下@2x.png": "3e8a",
	"./icon/icon_下拉箭头_白色_向上@2x.png": "bd64",
	"./icon/icon_下拉箭头_白色_向下@2x.png": "e4e5",
	"./icon/icon_下拉箭头_绿色_向上@2x.png": "db67",
	"./icon/icon_下拉箭头_绿色_向下@2x.png": "82b3",
	"./icon/icon_下拉箭头_黑色_向上@2x.png": "b2a3",
	"./icon/icon_下拉箭头_黑色_向下@2x.png": "0134",
	"./icon/icon_保存@2x.png": "3e1e",
	"./icon/icon_修改资料@2x.png": "eec0",
	"./icon/icon_卡片_位置@2x.png": "5cb0",
	"./icon/icon_卡片_提交@2x.png": "11fd",
	"./icon/icon_卡片_赛事认证@2x.png": "6e93",
	"./icon/icon_名字@2x.png": "bcbe",
	"./icon/icon_多选_未选中@2x.png": "edd9",
	"./icon/icon_多选_选中@2x.png": "a1e1",
	"./icon/icon_展开_灰色@2x.png": "015e",
	"./icon/icon_展开按钮_向下@2x.png": "52bc",
	"./icon/icon_已认证@2x.png": "198e",
	"./icon/icon_底部弹窗_select@2x.png": "8425",
	"./icon/icon_折叠按钮_向上@2x.png": "fd4d",
	"./icon/icon_排列_白色@2x.png": "3ce0",
	"./icon/icon_排列_黑色@2x.png": "a0ec",
	"./icon/icon_提示@2x.png": "4af7",
	"./icon/icon_提示_橙色@2x.png": "2e1f",
	"./icon/icon_提示_灰色@2x.png": "f1e4",
	"./icon/icon_提示_灰色_2@2x.png": "2d9f",
	"./icon/icon_提示_白色@2x.png": "05de",
	"./icon/icon_提示_红色@2x.png": "e771",
	"./icon/icon_提示_红色_2@2x.png": "5c4b",
	"./icon/icon_提示_绿色@2x.png": "bf20",
	"./icon/icon_收起@2x.png": "f771",
	"./icon/icon_收起_灰色@2x.png": "b2fa",
	"./icon/icon_文件列表_file@2x.png": "377a",
	"./icon/icon_文件列表_image@2x.png": "8444",
	"./icon/icon_文件列表_空白@2x.png": "a11e",
	"./icon/icon_旗帜@2x.png": "1274",
	"./icon/icon_未选@2x.png": "af3c",
	"./icon/icon_查看证书按钮@2x.png": "696b",
	"./icon/icon_电话@2x.png": "b45a",
	"./icon/icon_管理组合@2x.png": "e990",
	"./icon/icon_管理组合_选中@2x.png": "ed22",
	"./icon/icon_组合_关闭@2x.png": "4c459",
	"./icon/icon_说明@2x.png": "c74b",
	"./icon/icon_说明_灰色@2x.png": "5300",
	"./icon/icon_赛事广场卡片_报名中@2x.png": "9240",
	"./icon/icon_赛事广场卡片_未开赛@2x.png": "1270",
	"./icon/icon_赛事广场卡片_比赛中@2x.png": "b2e2",
	"./icon/icon_赛事等级徽章_A级@2x.png": "20fe",
	"./icon/icon_赛事等级徽章_B级@2x.png": "3cd0",
	"./icon/icon_赛事等级徽章_C级@2x.png": "4a88",
	"./icon/icon_赛事等级徽章_D级@2x.png": "4640",
	"./icon/icon_赛事等级徽章_E级@2x.png": "6d37",
	"./icon/icon_赛事详情卡片_地点@2x.png": "bb7e",
	"./icon/icon_选择@2x.png": "8c91",
	"./icon/icon_通知@2x.png": "0784",
	"./icon/icon_邮箱@2x.png": "1eff",
	"./icon/icon_重叠_白色@2x.png": "bb43",
	"./icon/icon_重叠_黑色@2x.png": "278e",
	"./icon/icon运动员等级_职工一级@2x.png": "6c42",
	"./icon/icon运动员等级_职工三级@2x.png": "7c86",
	"./icon/icon运动员等级_职工二级@2x.png": "31f4",
	"./icon/icon运动员等级_职工五级@2x.png": "9565",
	"./icon/icon运动员等级_职工四级@2x.png": "48e1",
	"./icon/match_events_down@2x.png": "2e22",
	"./icon/match_events_up@2x.png": "5470",
	"./icon/nav_更多@2x.png": "888e",
	"./icon/no_audit@2x.png": "7919",
	"./icon/no_doubles@2x.png": "8ecd",
	"./icon/top_tab@2x.png": "6376",
	"./icon/卡片_下端白色渐变蒙层@2x.png": "da0a",
	"./icon/定位@2x.png": "fab4",
	"./icon/新闻公告@2x.png": "fffd",
	"./icon/认证流程指引_序号一@2x.png": "a1c2",
	"./icon/认证流程指引_序号二@2x.png": "bc48",
	"./icon/认证流程指引_标签_平台@2x.png": "f2ad",
	"./icon/认证流程指引_标签_用户@2x.png": "742b",
	"./logo_新@2x.png": "f8a4",
	"./master_score/bg_大师分排行@2x.png": "76c8",
	"./master_score/bg_大师等级@2x.png": "9b57",
	"./master_score/bg_等级徽章@2x.png": "2c72",
	"./master_score/card_bg_等级徽章@2x.png": "c961",
	"./master_score/card_大师分排行@2x.png": "728a",
	"./master_score/card_大师等级@2x.png": "e2d4",
	"./master_score/card_掼蛋赛事@2x.png": "7db1",
	"./master_score/card_赛事认证@2x.png": "1f62",
	"./master_score/hint_气泡@2x.png": "357b",
	"./master_score/icon_上升@2x.png": "8486",
	"./master_score/icon_下降@2x.png": "b391",
	"./master_score/icon_持平@2x.png": "056e",
	"./master_score/medal/一星特级大师@2x.png": "9336",
	"./master_score/medal/一星高级大师@2x.png": "b7eb",
	"./master_score/medal/三星特级大师@2x.png": "95cf",
	"./master_score/medal/三星高级大师@2x.png": "a863",
	"./master_score/medal/二星特级大师@2x.png": "0bc4",
	"./master_score/medal/二星高级大师@2x.png": "bd0a",
	"./master_score/medal/五星特级大师@2x.png": "e571",
	"./master_score/medal/四星特级大师@2x.png": "34e1",
	"./master_score/medal/方块中级大师@2x.png": "401d",
	"./master_score/medal/方块初级大师@2x.png": "7943",
	"./master_score/medal/无等级@2x.png": "0f36",
	"./master_score/medal/梅花中级大师@2x.png": "b4c8",
	"./master_score/medal/梅花初级大师@2x.png": "aad9",
	"./master_score/medal/红心中级大师@2x.png": "6e9d",
	"./master_score/medal/红心初级大师@2x.png": "b229",
	"./master_score/medal/黑桃中级大师@2x.png": "191c",
	"./master_score/medal/黑桃初级大师@2x.png": "edac",
	"./master_score/tag/一星特级大师@2x.png": "97e0",
	"./master_score/tag/一星高级大师@2x.png": "5535",
	"./master_score/tag/三星特级大师@2x.png": "fbc8",
	"./master_score/tag/三星高级大师@2x.png": "2d5b",
	"./master_score/tag/二星特级大师@2x.png": "d7c6",
	"./master_score/tag/二星高级大师@2x.png": "bae3",
	"./master_score/tag/五星特级大师@2x.png": "0f45",
	"./master_score/tag/四星特级大师@2x.png": "78ba",
	"./master_score/tag/方块中级大师@2x.png": "f4d7",
	"./master_score/tag/方块初级大师@2x.png": "6a9d",
	"./master_score/tag/梅花中级大师@2x.png": "0847",
	"./master_score/tag/梅花初级大师@2x.png": "a0a4",
	"./master_score/tag/红心中级大师@2x.png": "3a41",
	"./master_score/tag/红心初级大师@2x.png": "9b52",
	"./master_score/tag/黑桃中级大师@2x.png": "fc21",
	"./master_score/tag/黑桃初级大师@2x.png": "0e81",
	"./master_score/tag_红分赛事@2x.png": "83fd",
	"./master_score/tag_金分赛事@2x.png": "56b6",
	"./master_score/tag_银分赛事@2x.png": "cafc",
	"./master_score/盖章@2x.png": "8d53",
	"./master_score/记录标题_left@2x.png": "850f",
	"./master_score/记录标题_right@2x.png": "e513",
	"./master_score/证书@2x.png": "9d52",
	"./match_detail/10_26@2x.png": "b5b7",
	"./match_detail/11_26@2x.png": "3e2a",
	"./match_detail/12_26@2x.png": "bdaa",
	"./match_detail/13_26@2x.png": "93c0",
	"./match_detail/14_26@2x.png": "a318",
	"./match_detail/15_26@2x.png": "8f35",
	"./match_detail/16_26@2x.png": "911c",
	"./match_detail/1_26@2x.png": "3c5d",
	"./match_detail/301_26@2x.png": "9108",
	"./match_detail/302_26@2x.png": "b057",
	"./match_detail/303_26@2x.png": "3f20",
	"./match_detail/304_26@2x.png": "3975",
	"./match_detail/3_26@2x.png": "d801",
	"./match_detail/4_26@2x.png": "77ee",
	"./match_detail/5_26@2x.png": "5e5b",
	"./match_detail/6_26@2x.png": "1651",
	"./match_detail/7_26@2x.png": "2e8c",
	"./match_detail/801_26@2x.png": "5fc0",
	"./match_detail/802_26@2x.png": "b49f",
	"./match_detail/8_26@2x.png": "906a",
	"./match_detail/9_26@2x.png": "0411",
	"./match_detail/A级赛事@2x.png": "ce07",
	"./match_detail/B级赛事@2x.png": "cec3",
	"./match_detail/C级赛事@2x.png": "1643",
	"./match_detail/D级赛事@2x.png": "205f",
	"./match_detail/E级赛事@2x.png": "6f75",
	"./match_detail/icon赛程赛果@2x.png": "0d2b",
	"./match_detail/icon通知@2x.png": "46e4",
	"./match_detail/icon附件文档@2x.png": "af75",
	"./match_detail/my_bubble_hint@2x.png": "da76",
	"./match_detail/share_bubble@2x.png": "c005",
	"./match_detail/气泡_1@2x.png": "bbff",
	"./match_detail/气泡_2@2x.png": "a924",
	"./match_detail/气泡_3@2x.png": "490c",
	"./match_detail/气泡_4@2x.png": "3132",
	"./news/cover@2x.png": "bd9f",
	"./no_data/referee_experience@2x.png": "ddb7",
	"./no_data/暂无内容@2x.png": "9e7a",
	"./no_data/暂无参赛信息@2x.png": "bb07",
	"./no_data/暂无参赛者报名@2x.png": "1bfb",
	"./no_data/暂无报名@2x.png": "372f",
	"./no_data/暂无比赛成绩@2x.png": "f675",
	"./no_data/暂无积分及等级记录@2x.png": "299c",
	"./no_data/暂无等级成长记录@2x.png": "a5b4",
	"./no_data/暂无赛事证书@2x.png": "9b69",
	"./no_data/暂无队员@2x.png": "73f2",
	"./portrait_photo_example@2x.png": "82f6",
	"./referee_coach/pattern_certificate@2x.png": "8f12",
	"./rules/bg@2x.png": "14c1",
	"./rules/icon/01_白色@2x.png": "e411",
	"./rules/icon/01_红色@2x.png": "5f77",
	"./rules/icon/02_白色@2x.png": "811d",
	"./rules/icon/02_红色@2x.png": "a0f2",
	"./rules/icon/03_白色@2x.png": "fdf2",
	"./rules/icon/03_红色@2x.png": "0a58",
	"./rules/icon/04_白色@2x.png": "7251",
	"./rules/icon/04_红色@2x.png": "0ede",
	"./rules/icon/icon-入口@2x.png": "6da2",
	"./rules/icon/icon_申请入会_会员申请书@2x.png": "a526",
	"./rules/icon/icon_申请入会_单位@2x.png": "b943",
	"./rules/icon/icon_申请入会_法人@2x.png": "9598",
	"./rules/icon/icon_申请入会_简介@2x.png": "6a3a",
	"./rules/中企logo_认证机构@2x.png": "9ca1",
	"./rules/协会伙伴logo@2x.png": "aab0",
	"./rules/插图_加入我们_01@2x.png": "8d0e",
	"./rules/插图_加入我们_02@2x.png": "edf8",
	"./rules/插图_加入我们_03@2x.png": "7e71",
	"./rules/插图_加入我们_04@2x.png": "09ab",
	"./serial_match/banner_1@2x.png": "c168",
	"./serial_match/bg_1@2x.png": "13c1",
	"./serial_match/card_moment@2x.png": "8a0a",
	"./serial_match/card_program@2x.png": "3150",
	"./serial_match/card_result@2x.png": "dd62",
	"./serial_match/masterImage_1@2x.png": "a214",
	"./serial_match/tabBar_1@2x.png": "3e6d",
	"./中企体协logo@2x.png": "a4a4",
	"./框_右上@2x.png": "b128",
	"./框_右上_绿色@2x.png": "689e",
	"./框_右下@2x.png": "32c9",
	"./框_右下_绿色@2x.png": "5bf4",
	"./框_左上@2x.png": "d955",
	"./框_左上_绿色@2x.png": "4f44",
	"./框_左下@2x.png": "8cc6",
	"./框_左下_绿色@2x.png": "b4a1",
	"./肖像@2x.png": "089d",
	"./证书框@2x.png": "7399",
	"./赛事logo_占位@2x.png": "4737",
	"./赛事管理办法@2x.png": "6da4",
	"./身份证_反面@2x.png": "1167",
	"./身份证_正面@2x.png": "67e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4fe3";